module.exports = __webpack_public_path__ + "static/media/lazyaz_app6_preview.b55c658a.jpg";